import { Component, OnInit, OnDestroy, ViewChild, TemplateRef, ChangeDetectorRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { ToastrService } from 'ngx-toastr';
import moment from 'moment';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { CommonService } from 'src/app/shareModule/services/common.service';

@Component({
    selector: 'app-map-forum',
    templateUrl: './map-forum.component.html',
    styleUrls: ['./map-forum.component.scss']
})
export class MapForumComponent implements OnInit, OnDestroy {

    public communityQuestionsAndAnswers = [];
    public categoryId: any;
    public filter: string = '';
    public filterId: string = '';
    public filterForum: string = '';
    private destroy$ = new Subject<void>();

    // Forum related properties
    detailForum: any = {};
    showMessageBoxReply: boolean = false;
    imgUrl: string = environment.ImageUrl;
    public isUserDisabled: boolean = false;
    isLogin: any = 0;
    appUserId: any;

    constructor(
        private modalService: NgbModal,
        private router: Router,
        private auth: AuthServiceService,
        public cdr: ChangeDetectorRef,
        private local: LocalServiceService,
        private toastr: ToastrService,
        public commonService: CommonService
    ) { }

    ngOnInit(): void {
        this.fetchCommunityQuestionsAnswers(this.categoryId);
        this.initForum();
        this.initUserDetails();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private initUserDetails() {
        this.local.getUserDetailsObserver().subscribe((user) => {
            if (user?.id) {
                this.isUserDisabled = user?.isDisabled;
                this.appUserId = user.id;
                this.isLogin = 1;
            } else {
                this.isLogin = 0;
            }
        });
    }

    public closeCommunityQuestionsModal() {
        this.modalService.dismissAll();
    }

    public navigateToForum(question: any) {
        if (question?.forum?.slug) {
            this.router.navigate(['/forum', question.forum.slug]);
            this.closeCommunityQuestionsModal();
        }
    }

    public fetchCommunityQuestionsAnswers(categoryId: any) {
        this.auth
            .getCommunityFAQQuestionsOfCategory(categoryId)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (data) => {
                    this.communityQuestionsAndAnswers = data.body;
                    this.cdr.detectChanges();
                },
                error: console.error,
            });
    }

    public initForum() {
        this.auth.forum_find(this.filterForum).subscribe((response: any) => {
            const item = response.body;

            this.detailForum = item;
            this.detailForum.createdAtText = this.local.timeAgo(item.createdAt)
            this.detailForum.images = Array.isArray(this.detailForum?.images)
                ? this.detailForum.images
                : JSON.parse(this.detailForum?.images ?? '[]');
            this.initReply(item.id);

            this.openReplies = false;
            this.cdr.detectChanges();

        }, (e) => {
            return;
        });
    }

    initReply(id: number) {
        this.auth
            .marketplace_forum_shop_fetch_reply(id, 1, true)
            .subscribe((response: any) => {
                this.detailForum.replies = response.body;
                this.cdr.detectChanges();
            });
    }

    // Helper methods for forum functionality
    isOwnMessage = (data: any) => {
        const user = this.local.getUser();
        if (!user) return false;
        return user.id == data.createdBy;
    };

    formatDate(value: any) {
        return moment.unix(value).format('YYYY-MM-DD HH:mm:ss');
    }

    // Handle reply options
    async handleShowOptionForumReply(index: number) {
        await Promise.all(
            this.detailForum?.replies.map((row: any, i: number) => {
                if (index != i) row.showOption = false;
            })
        ).then(() => {
            this.detailForum.replies[index].showOption =
                !this.detailForum.replies[index].showOption;
        });
    }

    async handleShowOptionForumReplyChild(item: any) {
        item.showOption = !item.showOption;
    }

    // Store forum message reply
    storeForumMessageReply(id: number = null, item: any = null) {
        if (this.isUserDisabled)
            return this.toastr.error('Your account is muted !');
        const forum = item != null ? item : this.detailForum;
        const isChild = item != null;
        if (forum.replyText.length < 1 && id == null) {
            return this.toastr.error('Please Fill a Message !');
        }

        this.detailForum.hasSubmit = true;
        const parentChild = isChild ? forum.id : null;

        if (id != null) {
            forum.replyText = forum.messageEdit;
        }

        const form = {
            forumId: isChild ? forum.forumId : forum.id,
            message: forum.replyText,
            createdBy: this.appUserId,
            id: id,
            isChild: isChild,
            parentChild: parentChild,
        };

        try {
            this.auth.marketplace_forum_shop_store_reply(form).subscribe(() => {
                this.detailForum.hasSubmit = false;
                Swal.fire({
                    title: 'Success',
                    text: 'The message was successfully added',
                    icon: 'success',
                    showCancelButton: false,
                    confirmButtonColor: 'var(--primary)',
                    confirmButtonText: 'OK',
                }).then(() => {
                    this.initReply(this.detailForum.id);
                    this.showMessageBoxReply = false;
                    this.cdr.detectChanges();
                });
                forum.replyText = '';
            });
        } catch (e) {
            this.detailForum.hasSubmit = false;
        }
    }

    storeForumMessageEdit(item: any) {
        this.storeForumMessageReply(item.id, item);
    }

    // Edit forum message
    editForumMessage(event: any, item: any) {
        if (this.isUserDisabled)
            return this.toastr.error('Your account is muted !');
        event.preventDefault();
        item.isEdit = !item.isEdit;
        item.messageEdit = item.message;
        item.showOption = false;
    }

    editForumMessageReply(event: any, item: any) {
        if (this.isUserDisabled)
            return this.toastr.error('Your account is muted !');
        event.preventDefault();
        item.isEdit = !item.isEdit;
        item.messageEdit = item.message;
        item.showOption = false;
    }

    // Delete forum message reply
    deleteForumMessageReply(event: any, id: any, index: number = null) {
        if (this.isUserDisabled)
            return this.toastr.error('Your account is muted !');
        event.preventDefault();
        this.local.alertConfirm({}).then((resp) => {
            if (resp.isConfirmed) {
                this.local.alertLoading({});
                try {
                    this.auth.marketplace_forum_shop_delete_reply(id).subscribe(() => {
                        this.local.alertSuccess({}).then(() => {
                            this.initReply(this.detailForum.id);
                            this.cdr.detectChanges();
                        });
                    });
                } catch (e) {
                    this.local.alertInternalError();
                }
            }
        });
    }

    // Show reply message box
    showReplyMessageBox(event: any, item: any) {
        event.preventDefault();
        item.showReplyBox = !item.showReplyBox;
    }

    // Like forum functionality
    hasCheckedForum(data: any) {
        return data?.filter((row: any) => row.userId == this.appUserId)?.length > 0;
    }

    likeForum(forumId: number, data: any) {
        if (this.isLogin == 0) {
            return this.toastr.error('Please Login First !');
        }
        if (this.isUserDisabled)
            return this.toastr.error('Your account is muted !');
        const payload = {
            userId: this.appUserId,
            forumId: forumId,
        };

        if (this.hasCheckedForum(data.forumLikes))
            data.forumLikes = data.forumLikes.filter(
                (row: any) => row.userId != this.appUserId
            );
        else data.forumLikes = [...data.forumLikes, payload];

        this.auth.forum_likes(payload).subscribe();
    }

    // Voting functionality
    handleVote(reply: any, voteType: 'upvote' | 'downvote', isChild: boolean = false) {
        if (this.isLogin == 0) {
            return this.toastr.error('Please Login First !');
        }
        if (this.isUserDisabled)
            return this.toastr.error('Your account is muted !');

        const payload = {
            replyId: reply.id,
            userId: this.appUserId,
            type: voteType,
            forumId: this.detailForum.id,
            isChild: isChild
        };

        this.auth.voteReply(payload).subscribe({
            next: (response: any) => {
                // Update with actual server response
                if (response.body) {
                    if (voteType === 'upvote') {
                        reply.upvotes += 1;
                    } else {
                        reply.downvotes += 1;
                    }
                    reply.userVote = voteType;
                } else {
                    if (voteType === 'upvote') {
                        reply.upvotes -= 1;
                    } else {
                        reply.downvotes -= 1;
                    }
                    reply.userVote = false;
                }
                this.cdr.detectChanges();
            },
            error: (error) => {
                this.toastr.error('Failed to vote. Please try again.');
                this.cdr.detectChanges();
            }
        });
    }

    openReplies: boolean = false;
    toggleReplies(reply: any) {
        reply.openReplies = !reply.openReplies;
    }
}
